<template>
    <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clip-path="url(#clip0_2126_209)">
            <mask id="mask0_2126_209" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="12"
                height="12">
                <rect x="0.166687" y="0.583344" width="11.6667" height="10.8333" fill="#D9D9D9" />
            </mask>
            <g mask="url(#mask0_2126_209)">
                <path
                    d="M4.36839 10.5026L4.48012 10.6908L4.68142 10.605L6.00002 10.0426L7.31861 10.605L7.51992 10.6908L7.63165 10.5026L8.36812 9.26226L9.76259 8.95238L9.97803 8.9045L9.95724 8.68479L9.82155 7.25028L10.7715 6.16463L10.9155 6L10.7715 5.83537L9.82155 4.74972L9.95724 3.31521L9.97803 3.0955L9.76259 3.04762L8.36812 2.73774L7.63165 1.49737L7.51992 1.30919L7.31861 1.39504L6.00002 1.95738L4.68142 1.39504L4.48012 1.30919L4.36839 1.49737L3.63192 2.73774L2.23745 3.04762L2.02201 3.0955L2.0428 3.31521L2.17849 4.74972L1.22854 5.83537L1.08449 6L1.22854 6.16463L2.17849 7.25029L2.0428 8.68479L2.02201 8.9045L2.23745 8.95238L3.63192 9.26226L4.36839 10.5026ZM5.56252 7.12561L4.43691 6L4.66875 5.76815L5.38784 6.47051L5.56459 6.64315L5.7393 6.46844L7.33022 4.87752L7.56621 5.12193L5.56252 7.12561Z"
                    fill="#3B82F6" stroke="#09090B" stroke-width="0.5" />
            </g>
        </g>
        <defs>
            <clipPath id="clip0_2126_209">
                <path
                    d="M0 6C0 2.68629 2.68629 0 6 0C9.31371 0 12 2.68629 12 6C12 9.31371 9.31371 12 6 12C2.68629 12 0 9.31371 0 6Z"
                    fill="white" />
            </clipPath>
        </defs>
    </svg>
</template>
